export default __webpack_public_path__ + "static/media/Audiophile - Preview 2.2e71105e.png";